<template>
  <el-drawer
    title="计划详情"
    :visible.sync="drawer"
    :direction="direction">
    <div class="detail-content">
      <p class="title">基本信息</p>
      <el-form :model="detail" :size="size" ref="dataForm" label-position='right' label-width="120px" >
        <el-form-item label="计划ID">
          <span>{{ detail.id }}</span>
        </el-form-item>
        <el-form-item label="计划名称">
          <span>{{ detail.name }}</span>
        </el-form-item>
        <el-form-item label="客户">
          <span>{{ detail.clientCompanyName }}</span>
        </el-form-item>
        <el-form-item label="类型">
          <span>{{ detail.type }}</span>
        </el-form-item>
        <el-form-item label="状态">
          <span>{{ detail.status }}</span>
        </el-form-item>
        <el-form-item label="创建人">
          <span>{{ detail.creatorNickname }}</span>
        </el-form-item>
        <el-form-item label="计划起止时间">
          <span>{{$moment(detail.startTime).format('YYYY/MM/DD')}} - {{$moment(detail.endTime).format('YYYY/MM/DD')}}</span>
        </el-form-item>
        <el-form-item label="描述">
          <span>{{ detail.describe }}</span>
        </el-form-item>
      </el-form>
      <p class="title">关联项目信息</p>
      <el-form :size="size" label-position='right' label-width="160px" >
        <el-form-item label="项目名称">
          <span>{{ project.projectName }}</span>
        </el-form-item>
        <el-form-item label="项目编号">
          <span>{{ project.projectNumber }}</span>
        </el-form-item>
        <el-form-item label="类型">
          <span>{{ project.specificationType ? typeList.find((c) => c.value == project.specificationType)["label"] : '' }}</span>
        </el-form-item>
        <el-form-item label="周期" v-if="project.specificationType === 3 || project.specificationType === 4">
          <span>{{ project.cycle ? cycleList.find((c) => c.value == project.cycle)["label"] : '' }}</span>
        </el-form-item>
        <el-form-item label="次数">
          <span>{{ project.times }} 次</span>
        </el-form-item>
        <el-form-item label="服务区域">
          <span>{{ project.regionName }}</span>
        </el-form-item>
        <el-form-item label="关联设备">
          <div class="tree-content">
            <el-tree
              :data="treeData"
              show-checkbox
              default-expand-all
              node-key="measureId"
              ref="tree"
              highlight-current
              :props="defaultProps">
            </el-tree>
          </div>
        </el-form-item>
        <el-form-item label="联系人">
          <span>{{ project.clientContactPerson }}</span>
        </el-form-item>
        <el-form-item label="联系号码">
          <span>{{ project.clientContactPhone }}</span>
        </el-form-item>
        <el-form-item label="经纬度">
          <span>{{ project.clientAddressLongitude }},{{ project.clientAddressLatitude }}</span>
        </el-form-item>
        <el-form-item label="地址信息">
          <span>{{ project.clientAddress }}</span>
        </el-form-item>
        <el-form-item label="详细地址">
          <span>{{ project.clientAddressDetail }}</span>
        </el-form-item>
      </el-form>
      <p class="title">关联工单信息</p>
      <el-form :size="size" label-position='right' label-width="160px" v-if="Object.keys(order).length > 0" >
        <el-form-item label="工单ID">
          <span>{{ order.id }}</span>
        </el-form-item>
        <el-form-item label="工单名称">
          <span>{{ order.name }}</span>
        </el-form-item>
        <el-form-item label="基地站">
          <span>{{ order.workBaseName }}</span>
        </el-form-item>
        <el-form-item label="类型">
          <span>{{ order.type ? typeList.find((c) => c.value == project.specificationType)["label"] : '' }}</span>
        </el-form-item>
        <el-form-item label="开始时间">
          <span>{{ order.startTime }}</span>
        </el-form-item>
        <el-form-item label="结束时间">
          <span>{{ order.endTime }}</span>
        </el-form-item>
        <el-form-item label="现场负责人">
          <span>{{ order.mainExecutorNickname }}</span>
        </el-form-item>
        <el-form-item label="协作人员">
          <span v-for="(staff, index) in order.teamMembers" :key="staff.userId">{{staff.nickname}}
            <span v-if="index < (order.teamMembers.length - 1)">、</span>
          </span>
        </el-form-item>
        <el-form-item label="关联设备">
          <div class="tree-content">
            <el-tree
              :data="treeData"
              show-checkbox
              default-expand-all
              node-key="measureId"
              ref="ordertree"
              highlight-current
              :props="defaultProps">
            </el-tree>
          </div>
        </el-form-item>
        <el-form-item label="状态">
          <span>{{ order.state ? orderStatusList.find((c) => c.value == order.state)["label"] : '' }}</span>
        </el-form-item>
        <el-form-item label="附件">
          <el-link type="primary" v-for="item in attachList" :key="item.uploaderId" @click="handleDownloadFile(item)" title="点击下载">
            {{ item.fileName }}
          </el-link>
        </el-form-item>
      </el-form>
      <div class="empty" v-else>
        未有工单信息
      </div>
    </div>
  </el-drawer>
</template>

<script>
import { downloadFileByBase64Data } from '@common/utils/file.js'
import tree from '@/utils/tree'
export default {
  name: 'detail',
  props: {
    statusList: Array,
    typeList: Array,
    cycleList: Array,
    orderStatusList: Array
  },
  data () {
    return {
      size: 'small',
      drawer: false,
      direction: 'rtl',
      treeData: [],
      detail: {},
      project: {},
      order: {},
      defaultProps: {
        label: 'measureName',
        children: 'children',
        disabled: this.disabledFn
      },
      attachList: []
    }
  },
  methods: {
    disabledFn () {
      return true
    },
    async init (row) {
      this.drawer = true
      this.treeData = []
      this.detail = {}
      this.project = {}
      this.order = {}
      this.attachList = []
      this.detail = Object.assign({}, row)
      this.detail.type = this.handleTypeFormat(this.detail.type)
      this.detail.status = this.handleStatusFormat(this.detail.status)
      const config = JSON.parse(this.detail.projectInfoVO.specificationConfig)
      this.project = {
        ...this.detail.projectInfoVO,
        ...config
      }
      const clientCompanyId = this.detail.clientCompanyId
      const res = await this.$api.electricOperations.getMOViewTreeNodes(clientCompanyId)
      if (res.success) {
        const list = res.data.map((item) => {
          return {
            ...item,
            disabled: true
          }
        })
        this.treeData = tree.creatMeasureTreeJson(list, 0)
      }
      const orderInfo = await this.$api.electricOperations.listElectricOperationsWorkOrdersByPlan([this.detail.id])
      if (orderInfo.success) {
        console.log(orderInfo.data[0].order)
        this.order = Object.assign({}, orderInfo.data[0].order)
        // 获取附件
        const fileRequestList = this.order.attachments.length > 0 ? this.order.attachments.map((item) => {
          return this.$api.file.pullCompanySmallFile(item.id)
        }) : []
        if (fileRequestList.length > 0) {
          Promise.all(fileRequestList).then((res) => {
            if (res[0].success) {
              console.log(res)
              this.attachList = res.map((item) => {
                return item.data
              })
            }
          })
        }
      }
      this.$nextTick(() => {
        const measureId = this.project.scopes.map((item) => {
          return item.measureId
        })
        this.$refs.tree.setCheckedKeys(measureId)
        this.$refs.ordertree.setCheckedKeys(measureId)
      })
      console.log(this.detail)
    },
    handleTypeFormat (cellValue) {
      let val = ''
      this.typeList.forEach((item) => {
        if (item.value == cellValue) {
          val = item.label
        }
      })
      return val
    },
    handleStatusFormat (cellValue) {
      let val = ''
      this.statusList.forEach((item) => {
        if (item.value == cellValue) {
          val = item.label
        }
      })
      return val
    },
    handleDownloadFile (file) {
      downloadFileByBase64Data(file.fileName, file.data, file.fileType)
    }
  }
}
</script>

<style lang="scss" scoped>
.detail-content {
  color: #333;
  padding: 16px;
  text-align: left;
  .title {
    font-size: 18px;
  }
}

.el-form-item {
  margin-bottom: 6px;
}

.tree-content {
  ::v-deep .el-checkbox.is-disabled.is-checked {
    color: #409EFF;
    .el-checkbox__inner {
      background-color: #409EFF;
      border-color: #409EFF;
      &::after {
        border-color: #FFF;
      }
    }
  }
}

.empty {
  padding: 16px;
  text-align: center;
  font-size: 16px;
  color: #333;
}

</style>
